<template>
  <div class="input-container theme--light v-card cbg-white-container">
    <div>
      <v-tabs v-model="tabs" background-color="transparent" class="border-bottom">
        <v-tab @change="changeTab(item)" v-for="(item, i) in items" :key="i">
          {{
          item.tabName
          }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tabs">
        <!-- .......... Pharmacy......... -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div v-if="tabs === 0">
                <center-approval-info :centerType="'pharmacy'"></center-approval-info>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- .......... Diagnostics ......... -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div v-if="tabs === 1">
                <center-approval-info :centerType="'diagnostics-lab'"></center-approval-info>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- .......... Bloodbank ......... -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div v-if="tabs === 2">
                <center-approval-info :centerType="'bloodbank'"></center-approval-info>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- .......... Ambulance ......... -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div v-if="tabs === 3">
                <center-approval-info :centerType="'ambulance'"></center-approval-info>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>
<script>
import { pickSvg } from "@/views/SVG";
import { bus } from "@/main.js";
const centerApprovalInfo = () =>
  import("@/components/ApprovalCenters/centerApprovalInfo.vue");
export default {
  data() {
    return {
      tabs: null,
      items: [
        { tabName: "Pharmacy" },
        { tabName: "Diagnostics" },
        { tabName: "Bloodbank" },
        { tabName: "Ambulance" }
      ]
    };
  },

  components: {
    ...pickSvg("filterSVG"),
    centerApprovalInfo
  },

  methods: {
    changeTab(tabInfo) {
      // this.$router.replace({
      //   path: "/CenterApproval",
      //   query: { tab: tabInfo.tabName },
      // });
    }
  }
};
</script>




